import { Lock, LockOpenIcon } from "lucide-react";
import { useState } from "react";

const Footer = () => {
  const [rickrolled, setRickrolled] = useState(false);

  const handleSecretClick = () => {
    setRickrolled(true);
  };
  return (
    <div id="projects" className="border-t border-white/20">
      <div className="container w-full mx-auto pt-10 pb-4">
        <div className="flex flex-col-reverse lg:flex-row items-center justify-between gap-8">
          <p className="text-sm text-white">
            Last updated: 2025-11-06 • Version 2.0.1
          </p>
          <a
            href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
            target="_blank"
            onClick={handleSecretClick}
            className="flex items-center gap-2 border border-white/55 rounded-md py-[4.5px] px-2 hover:bg-white/10 text-sm"
          >
            {rickrolled ? (
              <>
                <LockOpenIcon className="w-4 h-4 text-white" />
                Rickrolled 😂
              </>
            ) : (
              <>
                <Lock className="w-4 h-4 text-white" />
                Here's a secret
              </>
            )}
          </a>
        </div>

        <div className="w-full mx-auto text-center mt-4 text-sm">
          © {new Date().getFullYear()} Saurabh Sharma Timilsina • Built with
          React.js and Tailwind CSS.
        </div>
      </div>
    </div>
  );
};

export default Footer;
